import { Link } from "react-router-dom";
import RightSidebarCategory from "./category/RightSidebarCategory";
import { useState } from "react";
import { useSelector } from "react-redux";
import { BUYER_LOGIN_URL } from "../utils/Constants";

const CategoryNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { accessToken } = useSelector((state) => state.auth);

  const { cartCount } = useSelector((state) => state.cart);

  const handleMenu = () => {
    setIsOpen(true);
  };

  return (
    <header className="header bg-white border-bottom border-gray-100">
      <div className="container container-lg">
        <nav className="header-inner d-flex justify-content-between gap-8">
          <div className="flex-align menu-category-wrapper">
            <div className="category-two d-block">
              <button
                type="button"
                className="category__button flex-align gap-8 fw-medium bg-main-600 p-10 text-white"
                onClick={handleMenu}>
                <span className="icon text-2xl d-xs-flex d-none">
                  <i className="ph ph-dots-nine"></i>
                </span>
                <span className="d-sm-flex d-none">
                  <b>ALL</b>
                </span>
                <b>CATEGORIES</b>
              </button>
              <RightSidebarCategory isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
            <div className="header-menu d-lg-block d-none">
              <ul className="nav-menu flex-align ">
                <li className="on-hover-item nav-menu__item  activePage">
                  <Link to="/" className="nav-menu__link">
                    Home
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item ">
                  <Link to="/about" className="nav-menu__link">
                    About Us
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item">
                  <Link to="/buyer" className="nav-menu__link">
                    Buyer
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item has-submenu">
                  <Link to="#" className="nav-menu__link">
                    Seller
                  </Link>
                  <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/seller"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100">
                        {" "}
                        Seller Benefits
                      </Link>
                    </li>
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/verified-seller"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100">
                        {" "}
                        Verified Seller
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="on-hover-item nav-menu__item">
                  <Link to="#" className="nav-menu__link">
                    Category
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item">
                  <Link to="/marketing" className="nav-menu__link">
                    Marketing
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item ">
                  <Link to="/legal" className="nav-menu__link">
                    Legal
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item ">
                  <Link to="/franchise" className="nav-menu__link">
                    Franchise
                  </Link>
                </li>
                <li className="on-hover-item nav-menu__item has-submenu">
                  <Link to="/investor" className="nav-menu__link">
                    Investor
                  </Link>
                  <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/equity-share"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100">
                        {" "}
                        Equity Share
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-menu__item">
                  <Link to="/contact" className="nav-menu__link">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="header-right flex-align ">
            <Link
              to="/msme-registration"
              className="bg-main-600 text-white p-10 h-100 hover-bg-main-800 flex-align gap-8 text-md d-lg-flex d-none">
              <div className="d-flex text-16">
                <i className="ph ph-user"></i>
              </div>
              Manufacturer Registration
            </Link>
            <div className="me-8 d-lg-none d-block">
              <div className="header-two-activities flex-align flex-wrap gap-32">
                <button
                  type="button"
                  className="flex-align search-icon d-lg-none d-flex gap-4 item-hover-two">
                  <span className="text-2xl text-white d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass"></i>
                  </span>
                </button>
                {accessToken ? (
                  <Link
                    to={BUYER_LOGIN_URL}
                    className="flex-align flex-column gap-8 item-hover-two">
                    <span className="text-2xl text-white d-flex position-relative item-hover__text">
                      <i className="ph ph-user"></i>
                    </span>
                    <span className="text-md text-white item-hover__text d-none d-lg-flex">
                      Profile
                    </span>
                  </Link>
                ) : (
                  <Link
                    to="/login"
                    className="flex-align flex-column gap-8 item-hover-two">
                    <span className="text-2xl text-white d-flex position-relative item-hover__text">
                      <i className="ph ph-user"></i>
                    </span>
                    <span className="text-md text-white item-hover__text d-none d-lg-flex">
                      Profile
                    </span>
                  </Link>
                )}

                <Link
                  to="/cart"
                  className="flex-align flex-column gap-8 item-hover-two">
                  <span className="text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple"></i>
                    {cartCount > 0 && (
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-two-600 text-white text-xs position-absolute top-n6 end-n4">
                        {cartCount}
                      </span>
                    )}
                  </span>
                  <span className="text-md text-white item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                </Link>
              </div>
            </div>
            <button
              type="button"
              className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex">
              {" "}
              <i className="ph ph-list"></i>{" "}
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default CategoryNav;
